import { Rocket } from 'iconoir-react';

import i18n from '~/common/helpers/i18n';

export const createHeaderActionsConfig = (
  environment: string,
  showBetaCreateDeploy: (show: boolean) => void
) => [
  {
    icon: Rocket,
    text: i18n.t('common.actions.deploy'),
    role: [
      'DEPLOYMENT:CREATE',
      `DEPLOYMENT:CREATE{ENV=${environment?.toUpperCase()}}`
    ],
    'data-testid': 'run-button-create',
    action: () => {
      showBetaCreateDeploy(true);
    }
  }
];

export const createPathsConfig = (
  activeRealm: string,
  environment: string
) => ({
  editPipelinePath: `/${activeRealm}/design/v2/pipelines`,
  logsPath: `/${activeRealm}/operation/monitor/${environment}/pipeline-logs`
});
